import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectProductFieldValue } from 'services/products/selectors';

const selectReEntryPeriodDays = createDeepEqualSelector(
    makeSelectProductFieldValue('reEntryPeriodDays'),
    (reEntryPeriodDays: number) => reEntryPeriodDays
);

const makeSelectReEntryPeriodDays = (): typeof selectReEntryPeriodDays =>
    selectReEntryPeriodDays;

export { makeSelectReEntryPeriodDays };
